import Vue from 'vue'
import Router from 'vue-router'
import extendFn from '@/plugin/extendFn'

import HelloWorld from '@/components/HelloWorld'



Vue.use(Router)
Vue.use(extendFn);

export default new Router({
  mode: 'history',
  fallback: false,
  routes: [
    // {
    //   path: '/cimdr/',
    //   redirect: '/cimdr/pagse'
    //   // name: 'Pages',
    //   // component:resolve=>require(['@/components/Home/HomePages.vue'],resolve),
    // },
    , {
      path: '/',
      redirect: '/cimdr/',
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/cimdr/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld,
      meta: {
        keepAlive: false
      }
    }, {
      path: '/cimdr/',
      name: 'Pages',
      component: resolve => require(['@/components/Home/HomePages.vue'], resolve),
      meta: {
        keepAlive: false
      }
    }, {
      path: '/cimdr/',
      redirect: '/cimdr/',
      meta: {
        keepAlive: false
      }
    }, {
      path: '/cimdr/detail',
      name: 'Detail',
      component: resolve => require(['@/components/Detail/Detail.vue'], resolve),
      meta: {
        keepAlive: false
      }
    }, {
      path: '/cimdr/login',
      name: 'Login',
      component: resolve => require(['@/components/Login/login.vue'], resolve)
    }, {
      path: '/cimdr/forgetPWD',
      name: 'ForgetPWD',
      component: resolve => require(['@/components/Login/forgetPWD.vue'], resolve)
    }, {
      path: '/cimdr/register',
      name: 'Register',
      component: resolve => require(['@/components/Login/register.vue'], resolve)
    }, {
      path: '/cimdr/ChildDetail',
      name: 'Childs',
      component: resolve => require(['@/components/ChildDetail/ChildDetail.vue'], resolve)
    }, {
      path: '/cimdr/ChildDetailList',
      name: 'ChildList',
      component: resolve => require(['@/components/ChildDetailList/ChildDetailList.vue'], resolve),
      meta: {
        keepAlive: false
      }
    }, {
      path: '/cimdr/desc',
      name: 'desc',
      component: resolve => require(['@/components/picture/desc.vue'], resolve),

    }, {
      path: '/cimdr/info',
      name: 'info',
      component: resolve => require(['@/components/picture/info.vue'], resolve),

    }, {
      path: '/cimdr/grate',
      name: 'grate',
      component: resolve => require(['@/components/picture/grate.vue'], resolve),

    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js